import { person } from '@axo/shared/data-access/types';
import { UnfilteredConditionalArray } from '../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../ConditionalWrappers/useApplicationConditionalContext';
import { MarketCountryCode } from '@axo/shared/types';
import { useApplicationConditionalFilter } from '../ConditionalWrappers/useApplicationConditionalFilter';

export const unfilteredAddressTypes: UnfilteredConditionalArray<
  ApplicationConditionalContext,
  person.AddressType
> = [
  {
    value: person.AddressType.AddressAbroad,
    whitelist: [
      { marketCountry: [MarketCountryCode.Finland, MarketCountryCode.Sweden] },
    ],
  },
  {
    value: person.AddressType.AddressPosteRestante,
    whitelist: [{ marketCountry: [MarketCountryCode.Finland] }],
  },
  {
    value: person.AddressType.AddressCo,
    whitelist: [{ marketCountry: [MarketCountryCode.Sweden] }],
  },
  {
    value: person.AddressType.AddressSpecial,
    whitelist: [{ marketCountry: [MarketCountryCode.Sweden] }],
  },
];

export const useFilteredAddressTypes = () =>
  useApplicationConditionalFilter(unfilteredAddressTypes);
